/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedReceiptReadSchema } from '../models/PagedReceiptReadSchema';
import type { ReceiptCreateOrUpdateSchema } from '../models/ReceiptCreateOrUpdateSchema';
import type { ReceiptDetailSchema } from '../models/ReceiptDetailSchema';
import type { ReceiptFilterPaymentStatus } from '../models/ReceiptFilterPaymentStatus';
import type { ReceiptInvoiceType } from '../models/ReceiptInvoiceType';
import type { ReceiptListExportSchema } from '../models/ReceiptListExportSchema';
import type { ReceiptPatchSchema } from '../models/ReceiptPatchSchema';
import type { ReceiptPaymentType } from '../models/ReceiptPaymentType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReceiptsApi {
    /**
     * Create Receipt
     * Create receipt. Required Permission: create_self_receipt
     * @returns ReceiptDetailSchema Created
     * @throws ApiError
     */
    public static receiptsCreateReceiptPost({
        requestBody,
    }: {
        requestBody: ReceiptCreateOrUpdateSchema,
    }): CancelablePromise<ReceiptDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/receipts/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Receipt List
     * Get receipt list. Required Permission: list_receipt
     * @returns PagedReceiptReadSchema OK
     * @throws ApiError
     */
    public static receiptsGetReceiptListGet({
        invoicedFrom,
        invoicedTo,
        cancelled,
        userId,
        visitId,
        searching,
        paymentTypes,
        invoiceTypes,
        paymentStatus,
        locationId,
        limit = 100,
        offset,
    }: {
        invoicedFrom?: (string | null),
        invoicedTo?: (string | null),
        cancelled?: (boolean | null),
        userId?: (string | null),
        visitId?: (string | null),
        searching?: (string | null),
        paymentTypes?: (Array<ReceiptPaymentType> | null),
        invoiceTypes?: (Array<ReceiptInvoiceType> | null),
        paymentStatus?: (ReceiptFilterPaymentStatus | null),
        locationId?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedReceiptReadSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/receipts/',
            query: {
                'invoiced_from': invoicedFrom,
                'invoiced_to': invoicedTo,
                'cancelled': cancelled,
                'user_id': userId,
                'visit_id': visitId,
                'searching': searching,
                'payment_types': paymentTypes,
                'invoice_types': invoiceTypes,
                'payment_status': paymentStatus,
                'location_id': locationId,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Generate Export
     * Generate export of receipts. Required Permission: list_receipts
     * @returns any Accepted
     * @throws ApiError
     */
    public static receiptsGenerateExportPost({
        requestBody,
    }: {
        requestBody: ReceiptListExportSchema,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/receipts/export',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate Invoice
     * Generate invoice from receipt. Required Permission: generate_invoice
     * @returns void
     * @throws ApiError
     */
    public static receiptsGenerateInvoicePost({
        receiptId,
    }: {
        receiptId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/receipts/{receipt_id}/invoice/',
            path: {
                'receipt_id': receiptId,
            },
        });
    }
    /**
     * Get Receipt
     * Get receipt. Required Permission: get_receipt
     * @returns ReceiptDetailSchema OK
     * @throws ApiError
     */
    public static receiptsGetReceiptGet({
        receiptId,
    }: {
        receiptId: string,
    }): CancelablePromise<ReceiptDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/receipts/{receipt_id}',
            path: {
                'receipt_id': receiptId,
            },
        });
    }
    /**
     * Patch Receipt
     * Patch receipt. Required Permission: update_self_receipt
     * @returns ReceiptDetailSchema OK
     * @throws ApiError
     */
    public static receiptsPatchReceiptPatch({
        receiptId,
        requestBody,
    }: {
        receiptId: string,
        requestBody: ReceiptPatchSchema,
    }): CancelablePromise<ReceiptDetailSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/receipts/{receipt_id}/',
            path: {
                'receipt_id': receiptId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update Receipt
     * Update receipt. Required Permission: update_self_receipt
     * @returns ReceiptDetailSchema OK
     * @throws ApiError
     */
    public static receiptsUpdateReceiptPut({
        receiptId,
        requestBody,
    }: {
        receiptId: string,
        requestBody: ReceiptCreateOrUpdateSchema,
    }): CancelablePromise<ReceiptDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/receipts/{receipt_id}/',
            path: {
                'receipt_id': receiptId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Receipt
     * Delete receipt. <br>Required Permission: remove_receipt
     * @returns void
     * @throws ApiError
     */
    public static receiptsDeleteReceiptDelete({
        receiptId,
    }: {
        receiptId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/receipts/{receipt_id}/',
            path: {
                'receipt_id': receiptId,
            },
        });
    }
    /**
     * Get Receipt Suggestion
     * Get suggested receipt from k-batch. Required Permission: get_receipt
     * @returns ReceiptCreateOrUpdateSchema OK
     * @throws ApiError
     */
    public static receiptsGetReceiptSuggestionGet({
        kBatchId,
    }: {
        kBatchId: string,
    }): CancelablePromise<ReceiptCreateOrUpdateSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/receipts/suggest-from-kbatch/{k_batch_id}/',
            path: {
                'k_batch_id': kBatchId,
            },
        });
    }
    /**
     * Resend Receipt Email
     * Resend receipt email. <br>Required permission: resend_receipt_email
     * @returns void
     * @throws ApiError
     */
    public static receiptsResendReceiptEmailPost({
        receiptId,
    }: {
        receiptId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/receipts/{receipt_id}/resend/',
            path: {
                'receipt_id': receiptId,
            },
        });
    }
}
